module.exports = __webpack_public_path__ + "static/img/icon-wrapper.cdc5a0ad.svg";